'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteQueryBox', [function () {
      return {
        templateUrl: 'views/directives/notes/saNoteQueryBox.html',
        restrict: 'A',
        scope: {
          managementId: '@'
        },
        controller: ['$scope', function($scope) {
          $scope.state = {
            pillData: [],
            open: false
          };

          $scope.toggleFilterPanel = function() {
            $scope.state.open = !$scope.state.open;
          };
        }]
      }
    }]);
